module.exports = __webpack_public_path__ + "img/icon_sszt.cb672190.gif";